import { render, staticRenderFns } from "./ConsumerDashboardPostpaid_old.vue?vue&type=template&id=df8fca9c&scoped=true&"
import script from "./ConsumerDashboardPostpaid_old.vue?vue&type=script&lang=js&"
export * from "./ConsumerDashboardPostpaid_old.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerDashboardPostpaid_old.vue?vue&type=style&index=0&id=df8fca9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8fca9c",
  null
  
)

export default component.exports